import { KnowledgeChannel } from './types';

export const knowledgeLocales = ['en-gb', 'fr-fr'] as const;
export type KnowledgeLocale = (typeof knowledgeLocales)[number];

export function isKnowledgeLocale(locale: string): locale is KnowledgeLocale {
  return knowledgeLocales.includes(locale as KnowledgeLocale);
}

export function resolveKnowledgeLocale(locale: string | undefined): KnowledgeLocale {
  if (locale === 'fr-fr') {
    return 'fr-fr';
  }
  return 'en-gb';
}

interface KnowledgeCopy {
  helpIndexTitle: string;
  helpIndexIntro: string;
  heroIndexTitle: string;
  heroIndexIntro: string;
  channelLabel: Record<KnowledgeChannel, string>;
}

const copyByLocale: Record<KnowledgeLocale, KnowledgeCopy> = {
  'en-gb': {
    helpIndexTitle: 'How Can We Help?',
    helpIndexIntro: 'Find answers about booking, treatments, and your account.',
    heroIndexTitle: 'How Can We Help?',
    heroIndexIntro: 'Guidance for Urban practitioners using the Pro app.',
    channelLabel: {
      hero: 'Hero help',
      help: 'Help centre',
    },
  },
  'fr-fr': {
    helpIndexTitle: 'Comment pouvons-nous vous aider ?',
    helpIndexIntro: 'Réponses sur les réservations, les soins et votre compte.',
    heroIndexTitle: 'Aide Hero',
    heroIndexIntro: 'Guide pour les praticiens Urban utilisant l’application Pro.',
    channelLabel: {
      hero: 'Aide Hero',
      help: 'Centre d’aide',
    },
  },
};

export function getKnowledgeCopy(locale: string): KnowledgeCopy {
  return copyByLocale[resolveKnowledgeLocale(locale)];
}
